import React, { useState } from 'react';
import { Flex } from 'rebass/styled-components';

import { layout } from '../../../../constants/constants';
import { DeviceType } from '../../../hooks/use-breakpoint/device-type';
import useBreakpoint from '../../../hooks/use-breakpoint/useBreakpoint';
import { AlertsContent, IconPack } from '../../../models/app-data-model';
import ShIcon from '../../sh-icon/sh-icon';
import ShLink from '../../sh-link/sh-link';
import './global-alert.scss';

export type GlobalAlertProps = {
  alert: AlertsContent;
  index?: string;
  closeAlertCallback: (alert: AlertsContent) => void;
  iconPack: IconPack[];
};

const GlobalAlert: React.FC<GlobalAlertProps> = ({ alert, index, closeAlertCallback, iconPack }: GlobalAlertProps) => {
  const breakpoint = useBreakpoint();
  const isTabletOrSmaller = breakpoint < DeviceType.Desktop;
  const [showAlert, setShowAlert] = useState(true);

  const closeAlert = (): void => {
    setShowAlert(false);
    closeAlertCallback(alert);
  };

  return showAlert ? (
    <div key={index} className={alert.alert.type?.toLowerCase() + ' global-alert'}>
      <Flex className="alert-content" width={layout.pageWidth} px={layout.pagePaddingX}>
        <div className="text-section">
          <span className="header-body">
            <span className={alert.alert.type?.toLowerCase() + ' headline text'}>{alert.alert.headline + ':'}</span>
            <span className={'body text ' + alert.alert.type} dangerouslySetInnerHTML={{ __html: alert.alert.body }}></span>
          </span>
          {isTabletOrSmaller && (
            <button data-testid="close-btn" className="close-btn unstyled-btn" onClick={() => closeAlert()}>
              <ShIcon iconPack={iconPack} iconName="close" className={alert.alert.type?.toLowerCase() + ' close-btn-icon'} />
            </button>
          )}
        </div>
        <div className="button-section">
          {alert.primary_button?.text && (
            <ShLink
              className={alert.alert.type?.toLowerCase() + ' primary button'}
              title={alert.primary_button?.text}
              reference={alert.primary_button?.reference}
              onClick={alert.primary_button?.onClick}
              dataTestId="primary-button"
              featureToggles={[]}
            />
          )}
          {alert.secondary_button?.text && (
            <ShLink
              className={alert.alert.type?.toLowerCase() + ' secondary button'}
              title={alert.secondary_button?.text}
              reference={alert.secondary_button?.reference}
              onClick={alert.secondary_button?.onClick}
              dataTestId="secondary-button"
              featureToggles={[]}
            />
          )}
          {!isTabletOrSmaller && (
            <button data-testid="close-btn" className="close-btn unstyled-btn" onClick={() => closeAlert()}>
              <ShIcon iconPack={iconPack} iconName="close" className={alert.alert.type?.toLowerCase() + ' close-btn-icon'} />
            </button>
          )}
        </div>
      </Flex>
    </div>
  ) : null;
};

export default GlobalAlert;
